'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Detail = require('../Detail/Detail');

var _Detail2 = _interopRequireDefault(_Detail);

var _fabfitfunSharedGlobal = require('@bit/fabfitfun.shared.global.button');

var _fabfitfunSharedGlobal2 = _interopRequireDefault(_fabfitfunSharedGlobal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReferAFriend = function ReferAFriend(props) {
  var title = props.title,
      desc = props.desc,
      cta = props.cta;


  return _react2.default.createElement(
    _Detail2.default,
    { icon: 'fa-money-bill-wave', title: title, description: desc },
    _react2.default.createElement(_fabfitfunSharedGlobal2.default, {
      type: _fabfitfunSharedGlobal.buttonTypes.PRIMARY.value,
      action: _fabfitfunSharedGlobal.actionTypes.CALL_TO_ACTION.value,
      label: cta,
      onClick: function onClick() {
        window.location = '/invite/';
      }
    })
  );
};

exports.default = ReferAFriend;

//# sourceMappingURL=ReferAFriend.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bit/fabfitfun.shared.global.layout-reader/node_modules/@bit/fabfitfun.my-box.global.my-box-header/dist/ReferAFriend/ReferAFriend.js
// module id = 625
// module chunks = 0